import React from 'react';
import './ResultSorting.scss';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/arrow-down.svg';

interface Props {
  sortChanged: any;
  sort: any;
  currentSort: string;
  loading: boolean;
}

export const ResultSorting = ({ sortChanged, sort, currentSort, loading }: Props) => {
  return (
    <div className='result-sortBy-toggle'>
      <Dropdown className='download-toggle'>
        <Dropdown.Toggle
          className='button mt-0 basicLink svg-fill fw-bold override-background'
          variant=''
          disabled={loading}
        >
          <FormattedMessage id='ec.buttons.sortBy' defaultMessage='Sortieren nach' />
          <ArrowDownIcon className='arrow' />
        </Dropdown.Toggle>

        <Dropdown.Menu className='sorting-menu'>
          <Dropdown.ItemText>
            <FormattedMessage id='ec.buttons.sortByAddress' defaultMessage='Sortieren nach Adresse' />
          </Dropdown.ItemText>
          <Dropdown.Item onClick={() => sortChanged('name', 1)}>
            <div className='d-flex align-items-center justify-content-start gap-3 customRadio'>
              <input
                type='radio'
                name='name-1'
                value={'name-1'}
                onChange={() => {}}
                checked={currentSort === 'name' && sort?.name == 1}
              />
              <div className='d-flex flex-column align-items-start justify-content-center'>
                <div className='title'>
                  <FormattedMessage id='ec.buttons.aToZ' defaultMessage='A bis Z' />
                </div>
                <div className='subtitle'>
                  <FormattedMessage id='ec.buttons.ascendingOrder' defaultMessage='aufsteigend' />
                </div>
              </div>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => sortChanged('name', 0)}>
            <div className='d-flex align-items-center justify-content-start gap-3 customRadio'>
              <input
                type='radio'
                name='name-0'
                value={'name-0'}
                onChange={() => {}}
                checked={currentSort === 'name' && sort?.name == 0}
              />
              <div className='d-flex flex-column align-items-start justify-content-center'>
                <div className='title'>
                  <FormattedMessage id='ec.buttons.ztoA' defaultMessage='Z bis A' />
                </div>
                <div className='subtitle'>
                  <FormattedMessage id='ec.buttons.descendingOrder' defaultMessage='absteigend' />
                </div>
              </div>
            </div>
          </Dropdown.Item>
          <Dropdown.ItemText>
            <FormattedMessage id='ec.buttons.sortPyPrice' defaultMessage='Sortieren nach Preis' />
          </Dropdown.ItemText>
          <Dropdown.Item onClick={() => sortChanged('price', 1)}>
            <div className='d-flex align-items-center justify-content-start gap-3 customRadio'>
              <input
                type='radio'
                name='price-1'
                value={'price-1'}
                onChange={() => {}}
                checked={currentSort === 'price' && sort?.price == 1}
              />
              <div className='d-flex flex-column align-items-start justify-content-center'>
                <div className='title'>
                  <FormattedMessage id='ec.buttons.ascendingOrder' defaultMessage='aufsteigend' />
                </div>
              </div>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => sortChanged('price', 0)}>
            <div className='d-flex align-items-center justify-content-start gap-3 customRadio'>
              <input
                type='radio'
                name='price-0'
                value={'price-0'}
                onChange={() => {}}
                checked={currentSort === 'price' && sort?.price == 0}
              />
              <div className='d-flex flex-column align-items-start justify-content-center'>
                <div className='title'>
                  <FormattedMessage id='ec.buttons.descendingOrder' defaultMessage='absteigend' />
                </div>
              </div>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
